import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banners-section"
}
const _hoisted_2 = { class: "banner-rows" }
const _hoisted_3 = { class: "banner-coin-exchange" }
const _hoisted_4 = ["src"]

export function render(_ctx, _cache) {
  return (!_ctx.hideBanner)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.getImage(),
              onError: _cache[0] || (_cache[0] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args))),
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.openCoinExchange()))
            }, null, 40, _hoisted_4)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}